import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { ApiConstant } from '../api-constant/api-constant.service';

export interface GeneralBantuan {
  ces_id: number;
  emoscore_id: number;
  page_url: string;
  page_name: string;
  browser_name: string;
  journey_point: string;
  submitted_at: Date;
  topbar_id: number;
  version_code: string;
  version_name: string;
  description?: string;
  citizen_id?: string;
  contactAddress_city?: string;
  dob?: string;
  domicileAddress_city?: string;
  education_type?: string;
  email?: string;
  gender?: string;
  income_employmentstatus?: string;
  income_jobtype?: string;
  income_workposition?: string;
  loanpurpose_type?: string;
  media?: string;
  mediasource?: string;
  name?: string;
  phone?: string;
  screenshot?: any;
}
export class API {
/**
 * @param {?} apiConstant
 * @param {?} http
 */
constructor(private apiConstant: ApiConstant,
private http: HttpClient) {}
/**
 * \@name - postToGeneralBantuan
 * @param {?} body
 * @return {?}
 */
public postToGeneralBantuan(body: GeneralBantuan): Observable<any> {
    return this.http.post(
      `${this.apiConstant.apiURL}/v3/general/bantuan`,
      body,
    );
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ApiConstant, },
{type: HttpClient, },
];
}

function API_tsickle_Closure_declarations() {
/** @type {?} */
API.decorators;
/**
 * @nocollapse
 * @type {?}
 */
API.ctorParameters;
/** @type {?} */
API.prototype.apiConstant;
/** @type {?} */
API.prototype.http;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
